import makeFetch from "../../utils/http";

export function api_getUserPartners() {
    return makeFetch(
        "partners",
        "GET"
    );
}

export function api_getPartnerById(id) {
    return makeFetch(
        `partners/${id}`,
        "GET"
    );
}

export function api_setPartnerPreferences(body) {
    return makeFetch(
        "partners",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_patchPartnerPreferences(id, body) {
    return makeFetch(
        `partners/${id}`,
        "PATCH",
        {},
        JSON.stringify(body)
    );
}

export function api_getPartnerURLUploadLogo(id) {
    return makeFetch(
        `partners/${id}/upload`,
        "GET"
    );
}


